import React from 'react';
import siteContent from '../../data/siteContent';

function Navbar({ menuOpen, setMenuOpen }) {
  const budgetLink = `https://wa.me/${siteContent.whatsapp.number}?text=${encodeURIComponent(siteContent.whatsapp.budgetMessage)}`;

  return (
    <nav>
      <a href="#home" className="nav-logo">
        <span className="wordmark">
          <img style={{height: "30px"}} src='../../logo.png'></img>
        </span>
      </a>

      <ul className="nav-links">
        {siteContent.nav.map((item) => (
          <li key={item.href}>
            <a href={item.href}>{item.label}</a>
          </li>
        ))}
      </ul>

      {/* <a href={budgetLink} className="btn-nav" target="_blank" rel="noreferrer">
        Solicitar Orçamento
      </a> */}

      <button
        className={`nav-hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Menu"
      >
        <span />
        <span />
        <span />
      </button>
    </nav>
  );
}

export default Navbar;